"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFullFillmentsColumns = void 0;
const minOrderQtyValueGetter = (params) => {
    if (params.data.label_fm_stocked == true) {
        return 1;
    }
    if (params.data.package_size) {
        return 960 / params.data.package_size;
    }
    return 960;
};
function OrderFullFillmentsColumns() {
    return [
        {
            field: 'order_id',
            headerName: 'Order ID',
            editable: false,
            maxWidth: 100,
            type: 'derivedColumn',
        },
        {
            field: 'from_company_name',
            headerName: 'Lieferant',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'to_company_name',
            headerName: 'Besteller',
            editable: false,
            minWidth: 150,
            type: 'derivedColumn',
        },
        {
            field: 'botanisch',
            headerName: 'Botanisch',
            editable: false,
            minWidth: 300,
            type: 'derivedColumn',
        },
        {
            field: 'tb',
            editable: false,
            headerName: 'Tb',
            maxWidth: 75,
            type: 'derivedColumn',
        },
        {
            field: 'pg',
            editable: false,
            headerName: 'PG',
            maxWidth: 75,
            type: 'derivedColumn',
        },
        {
            field: 'ean',
            headerName: 'EAN',
            editable: false,
            minWidth: 125,
            type: 'derivedColumn',
        },
        {
            field: 'interne_art_nr',
            headerName: 'Interne Art.-Nr.',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'be_art_nr',
            headerName: 'BE-Art.-Nr.',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'floramedia_art_nr',
            headerName: 'FAN',
            headerTooltip: 'Floramedia Artikel Nummer',
            editable: false,
            minWidth: 125,
            type: 'derivedColumn',
        },
        {
            field: 'quantity',
            editable: false,
            headerName: 'Bestellmenge',
            type: 'derivedColumn',
        },
        {
            field: 'filled_quantity',
            editable: true,
            headerName: 'Erhalten',
        },
    ];
}
exports.OrderFullFillmentsColumns = OrderFullFillmentsColumns;
